import { db, type TaxonomyCacheRecord } from './database'

const TAXONOMY_CACHE_KEY = 'latest'

export async function saveTaxonomyCache(
  record: Omit<TaxonomyCacheRecord, 'id'>,
): Promise<void> {
  await db.taxonomy.put({
    ...record,
    id: TAXONOMY_CACHE_KEY,
  })
}

export async function getTaxonomyCache(): Promise<TaxonomyCacheRecord | null> {
  const record = await db.taxonomy.get(TAXONOMY_CACHE_KEY)
  return record || null
}

export async function clearTaxonomyCache(): Promise<void> {
  await db.taxonomy.delete(TAXONOMY_CACHE_KEY)
}

export type { TaxonomyCacheRecord }
